import { Injectable } from '@angular/core';
import {
  ContactChangeResponse,
  InitiateContactChangeRequest,
  ResendContactCodeRequest,
  UpdateNewContactValueRequest,
  VerifyContactRequest,
} from '@models';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { ContactChangeService } from './contact-change.service';

@Injectable({ providedIn: 'root' })
export class ContactChangeApiService
  extends HttpService<ContactChangeResponse>
  implements ContactChangeService
{
  protected override readonly collectionPath = '/me/contact-changes';

  initiate(
    req: InitiateContactChangeRequest
  ): Observable<ContactChangeResponse> {
    return this.http.post<ContactChangeResponse>(this.apiUrl, req);
  }

  getStatus(id: string): Observable<ContactChangeResponse> {
    return this.http.get<ContactChangeResponse>(`${this.apiUrl}/${id}`);
  }

  verifyCurrent(
    id: string,
    req: VerifyContactRequest
  ): Observable<ContactChangeResponse> {
    return this.http.post<ContactChangeResponse>(
      `${this.apiUrl}/${id}/verify-current`,
      req
    );
  }

  updateNewValue(
    id: string,
    req: UpdateNewContactValueRequest
  ): Observable<ContactChangeResponse> {
    return this.http.put<ContactChangeResponse>(
      `${this.apiUrl}/${id}/new-value`,
      req
    );
  }

  verifyNew(
    id: string,
    req: VerifyContactRequest
  ): Observable<ContactChangeResponse> {
    return this.http.post<ContactChangeResponse>(
      `${this.apiUrl}/${id}/verify-new`,
      req
    );
  }

  resend(
    id: string,
    req: ResendContactCodeRequest
  ): Observable<ContactChangeResponse> {
    return this.http.post<ContactChangeResponse>(
      `${this.apiUrl}/${id}/resend`,
      req
    );
  }

  cancel(id: string): Observable<ContactChangeResponse> {
    return this.http.delete<ContactChangeResponse>(`${this.apiUrl}/${id}`);
  }
}
